var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"products-list"},_vm._l((_vm.visibleProducts),function(product){return _c('ProductsListItem',{key:product.CODARTICULO,attrs:{"product":product},on:{"ProductSelected":_vm.onProductSelected}})}))}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0e06fd85","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Products/ProductsList.vue
// module id = null
// module chunks = 